/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateOrganisationIdentifierCommand {
    /**
     * The integration identifier
     */
    integration: UpdateOrganisationIdentifierCommand.Integration;
    /**
     * The user\'s identifier
     */
    identifier: string;
    /**
     * The user\'s password
     */
    credentials: string;
}
export namespace UpdateOrganisationIdentifierCommand {
    export type Integration = 'ASA';
    export const Integration = {
        ASA: 'ASA' as Integration
    };
}
